'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');

class FormUtil {
  constructor() {
    this.insertDataToGoogleSheetV2 = async (config, formData, url) => {
      try {
        const res = this.api.post(url, {
          merchantId: config == null ? void 0 : config.merchantId,
          formAccountId: config == null ? void 0 : config.formAccountId,
          spreadSheetId: config == null ? void 0 : config.spreadSheetId,
          sheetId: config == null ? void 0 : config.sheetId,
          formData
        });
        return res;
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    };
    this.submitFormData = async (formId, formData, url) => {
      try {
        const res = this.api.post(url, {
          formId,
          formData
        });
        return res;
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    };
    this.api = new coreRenderer.Api("");
  }
}
const formUtils = new FormUtil();

exports.FormUtil = FormUtil;
exports.formUtils = formUtils;
